module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\n\n<form id=\"swh-mailmap-form\" class=\"text-left\">\n  <div class=\"form-group\">\n    <label for=\"swh-mailmap-from-email\">Email address</label>\n    <input type=\"email\" class=\"form-control\" id=\"swh-mailmap-from-email\" value=\"")
    ; __append(escapeFn( email ))
    ; __append("\"\n           ")
    ;  if (updateForm) { 
    ; __append(" readonly=\"readonly\" ")
    ;  } 
    ; __append(" required>\n  </div>\n  <div class=\"form-group\">\n    <label for=\"swh-mailmap-display-name\">Display name</label>\n    <input class=\"form-control\" id=\"swh-mailmap-display-name\" value=\"")
    ; __append(escapeFn( displayName ))
    ; __append("\" placeholder=\"John Doe <jdoe@example.org>\" required>\n  </div>\n  <div class=\"custom-control custom-checkbox\">\n    <input class=\"custom-control-input\" type=\"checkbox\" value=\"\" id=\"swh-mailmap-display-name-activated\"\n           ")
    ;  if (displayNameActivated) { 
    ; __append(" checked=\"checked\" ")
    ;  } 
    ; __append(">\n    <label class=\"custom-control-label pt-0\" for=\"swh-mailmap-display-name-activated\">Activate display name</label>\n  </div>\n  <div class=\"d-flex justify-content-center\">\n    <input id=\"swh-mailmap-form-submit\" type=\"submit\" value=\"")
    ; __append(escapeFn( buttonText ))
    ; __append("\">\n  </div>\n</form>")
  }
  return __output;

}